// React
import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import { withStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

class ImportAccountDiffTable extends React.Component {

    static propTypes = {
        classes: PropTypes.object.isRequired,
        items: PropTypes.array,
        title: PropTypes.string,
        keys: PropTypes.array
    };

    render() {
        const { classes, items, title, keys } = this.props;

        return (
            <div className={classes.root}>
                <Typography component='div' className={classes.title}>
                    {title}
                </Typography>
                <TableContainer className={classes.root} component={Paper}>
                    <Table className={classes.table} size='small' aria-label='a dense table'>
                        <TableHead>
                            <TableRow>
                                {keys.map(k => <TableCell key={k} align='left'>{k}</TableCell>)}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {items.map((item, index) =>
                                <TableRow key={index}>
                                    {keys.map(k => <TableCell key={item.key[k]} align='left'>{item.key[k]}</TableCell>)}
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        );
    }
}

const styles = theme => ({
    root: {
        width: '100%'
    },
    title: {
        flex: '1 1 100%',
        paddingLeft: '12px',
        backgroundColor: theme.palette.grey.light
    }
});

export default withStyles(styles)(ImportAccountDiffTable);
